export default __webpack_public_path__ + "static/media/Metropolis-SemiBold.015736ac.woff2";